/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-01-16 15:15:58
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-12-13 18:18:10
 * @FilePath: \sns-user-frontend\src\jsBridgeApi\oppo.js
 * @Description: 
 */
import { setCookie } from '@/utils'

export default {
  // 跳转动作
  openBrowser (jumpTarget, type = 'pkg') {
    if (type === 'link') {
      window.open(jumpTarget || location.href)
      return
    }
    window.appJsBridge.callApi('openApp', {
      pkg: jumpTarget
    })
  },
  // 隐藏客户端头部
  hideClientTitle () {},
  // 关闭客户端loading
	closeLoading () {},
  // 开启新容器
	openNewWebview (url) {},
  // 获取手机型号
  getDeviceName () {},
  // 调起客户端给登录页面
	loginPage () {
    window.appJsBridge.callApi('doStartLogin', {
      refresh: true
    })
  },
	// 获取登录态
	getToken () {
    let { code, data} = window.appJsBridge.callApi('getToken')
    if (code !== 0) return
    const { data: loginInfo } = window.appJsBridge.callApi('getLoginInfo')
    if (loginInfo) {
      const deviceId = loginInfo.split(';')[3]
      if (deviceId) {
        data = `${data}&&default&&default&&${deviceId}`
      }
      const clientParam = this.getBundleParams()
      setCookie("clientParam", encodeURIComponent(clientParam));
    }
    setCookie("token", data);
  },
	// 返回上一级/销毁当前容器
	goBack () {},
	
	share (data) {},
	// 获取设备信息
	getDeviceInfo () {
    const { code, data} = window.appJsBridge.callApi('getDeviceInfo')
    if (code !== 0) return
    return data
  },
	// 获取客户端消息
	getClientContext () {},
  // 获取版本信息
	getSdkVersion () {},
	// 获取客户端消息
	getAppInfo () {},
	getNetworkState() {},
	// 监听返回页面回调
	onResume(callback) {},

  // 询问权限获取
  onManageSystemPermission() {},
  // 打开app详情页
  openAppInfo (appId) {
    if (!appId) return
    const deepLink = `oap://mk/dt?id=${appId}`
    const { code} = window.appJsBridge.callApi('openPage', {
      url: deepLink
    })
    if (code !== 0) {
      window.open(deepLink)
    }
  }, 
  downloadApp (id, packageName) {
    window.appJsBridge.callApi('downloadGameByPackageName', { 
      id, packageName
    })
  },
  cancelDownload (packageName) {
    window.appJsBridge.callApi('cancelDownload', {
      packageName
    })
  },
  getDownloadStatus (packageName) {
    const { code, data} = window.appJsBridge.callApi('getButtonStatus', {
      packageName
    })
    if (code !== 0) return '0'
    return data
  },
  getDownloadProgress (packageName) {
    const { code, data } = window.appJsBridge.callApi('getProgress', {
      packageName
    })
    if (code !== 0) return '0'
    return data
  },
  pauseDownload (packageName) {
    window.appJsBridge.callApi('pauseDownload', {
      packageName
    })
  },
  continueDownload (packageName) {
    window.appJsBridge.callApi('resumeDownloadByMarket', {
      packageName
    })
  },
  getBundleParams () {
    const { code, data} = window.appJsBridge.callApi('getBundleAppParams', {
      url: location.origin
    })
    if (code !== 0) return ''
    return data
  }
}